import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-period-filter',
  templateUrl: './period-filter.component.html',
  styleUrls: ['./period-filter.component.scss']
})
export class PeriodFilterComponent implements OnInit {
  @Input() title!: string;
  @Input() subTitle!: string;
  @Input() showBadgeDate: boolean = true;
  @Output() rangeChange = new EventEmitter<{ start: Date; end: Date }>();
  @Input() emitOnInit = false;
  @Input() scheduling = false;
  calendarIsOpen = false;

  form: FormGroup;
  selectedDays: number = 7;
  dayOptions = [7, 15, 30, 45];

  constructor(private fb: FormBuilder) {
    const end = new Date();
    const start = this.getDateNDaysAgo(this.selectedDays);

    this.form = this.fb.group({
      start: [start],
      end: [end]
    });
  }

  ngOnInit(): void {
    if (this.emitOnInit) {
      this.emitRange();
    }
  }

  selectDays(days: number) {
    this.selectedDays = days;
    const end = this.scheduling ? this.getDateNDaysLater(days) : new Date();
    const start = this.scheduling ?  new Date() : this.getDateNDaysAgo(days);
    this.form.patchValue({ start, end });
    this.emitRange();
  }

  onRangeChange(range: { start: Date, end: Date }) {
    this.form.patchValue({ start: range.start, end: range.end });
    this.emitRange();

    // Desmarcar botões se não bater com os filtros rápidos
    const diff = this.calculateDiffInDays(range.start, range.end);
    if (!this.dayOptions.includes(diff)) {
      this.selectedDays = -1;
    } else {
      this.selectedDays = diff;
    }
  }

  emitRange() {
    const { start, end } = this.form.value;
    this.rangeChange.emit({ start, end });
  }

  getDateNDaysAgo(days: number): Date {
    const d = new Date();
    d.setDate(d.getDate() - days + 1);
    return d;
  }

  getDateNDaysLater(days: number): Date {
    const d = new Date();
    d.setDate(d.getDate() + days + 1);
    return d;
  }

  calculateDiffInDays(start: Date, end: Date): number {
    const s = new Date(start).setHours(0, 0, 0, 0);
    const e = new Date(end).setHours(0, 0, 0, 0);
    return Math.round((e - s) / (1000 * 60 * 60 * 24)) + 1;
  }
}
